/// <reference path='../../app.typings.d.ts' />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var OrganizationSelectorLinkDirective = /** @class */ (function () {
            function OrganizationSelectorLinkDirective() {
                this.controller = Directives.OrganizationSelectorLinkController;
                this.controllerAs = 'ctrl';
                this.replace = true;
                this.restrict = 'E';
                this.templateUrl = 'app/directives/ap-organization-selector-link/template.html';
                this.scope = {
                    activeOrganizationCacheKey: '@',
                    highlightSubOrganization: '@',
                    organization: '=',
                    onOrganizationChange: '&'
                };
            }
            OrganizationSelectorLinkDirective.factory = function () {
                var directive = function () {
                    return new OrganizationSelectorLinkDirective();
                };
                directive['$inject'] = [];
                return directive;
            };
            return OrganizationSelectorLinkDirective;
        }());
        angular.module('app.Directives')
            .directive('apOrganizationSelectorLink', OrganizationSelectorLinkDirective.factory());
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
